import React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Button
} from "@material-ui/core";
import t from "../../languages/pl";

const useStyles = theme => ({
    dialogActions: {
        display: 'flex',
        justifyContent: "flex-end",
        alignItems: "center"
    },
    checkbox: {
        color: "grey"
    },
    formControl: {
        marginLeft: theme.spacing(1)
    },
    backdrop: {
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(1px)"
    },
    typography: {
        lineHeight: 1.5,
        fontSize: '0.8rem',
        textAlign: 'justify',
        padding: theme.spacing(2)
    }
});

const RodoDialog = props => {
    const { classes, open, onClose } = props;
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            style={{ zIndex: 2001 }}
            BackdropProps={{
                classes: { root: classes.backdrop }
            }}
        >
            <DialogTitle>
                {t.rodoAcceptationTitle}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" className={classes.typography}>
                    {t.rodoAcceptationContent1}
                    <br />
                    {t.rodoAcceptationContent2}
                    <br />
                    {t.rodoAcceptationContent3}
                    <br />
                    {t.rodoAcceptationContent4}
                    <br />
                    {t.rodoAcceptationContent5}
                    <br />
                    {t.rodoAcceptationContent6}
                    <br />
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClose}
                >
                    {t.rodoAccept}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

RodoDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default withStyles(useStyles)(RodoDialog);
